import { useDiscountApi } from "../api/DiscountApiClient";
import { DiscountFrontendService } from "../services/DiscountFrontendService";

export const useDiscountService = (): DiscountFrontendService =>
  new DiscountFrontendService(useDiscountApi());
